import { render } from "./NftImage.vue?vue&type=template&id=332851d3&scoped=true"
import script from "./NftImage.vue?vue&type=script&lang=js"
export * from "./NftImage.vue?vue&type=script&lang=js"

import "./NftImage.vue?vue&type=style&index=0&id=332851d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332851d3"]])

export default __exports__